import { render, staticRenderFns } from "./Locacao.vue?vue&type=template&id=cff85c90&scoped=true&"
import script from "./Locacao.vue?vue&type=script&lang=js&"
export * from "./Locacao.vue?vue&type=script&lang=js&"
import style0 from "./Locacao.vue?vue&type=style&index=0&id=cff85c90&scoped=true&lang=css&"
import style1 from "./Locacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff85c90",
  null
  
)

export default component.exports